
export const Content = {
    HEADCOUNT_REQUIRED: "This field is required.",
    HEADCOUNT_CORRECT_NUMBER: "The value must be a number.",
    HEADCOUNT_NEGATIVE: "Headcount Value cannot be negative",
    PAST_QUOTE_REQUIRED: "This field is required.",
    PAST_QUOTE_CORRECT: "Enter Correct Text Field",
    CURRENT_UTLIZATION_REQUIRED: "This field is required.",
    CURRENT_UTLIZATION_CORRECT: "Enter Correct Text Field",
    JOURNEY_DATE_REQUIRED: "This field is required.",
    PAST_DATE_NOT_ALLOWED: "Past dates are not allowed",
    NUMBER_RAM_REQUIRED: "This field is required.",
    NUMBER_RAM_CORRECT: "Please Enter Correct number",
    NUMBER_RAM_NEGATIVE: "Number RAM cannot be negative",
    SAM_PRICING_REQUIRED: "This field is required.",
    SAM_PRICING_CORRECT: "Enter Correct Text Field",
    SELECT_OPTION: "This field is required.",
    SESSION_REQUIRED: "This field is required.",
    VALID_SESSION: "Please enter a valid session value",
    SESSION_LIMIT: "Number should be less than 25 and greater than 0",
    UTLIZATION_NUMBER_REQUIRED: "This field is required.",
    UTLIZATION_NUMBER_VALID: "Please Enter a valid number",
    UTLIZATION_NUMBER_GREATER: "This field cannot be negative or zero.",
    AM_OURS_REQUIRED: "This field is required.",
    ADDITIONAL_NOTES_REQUIRED: "This field is required.",
    HOURS_REQUIRED: "This field is required.",
    VALID_HOURS: "Please enter a valid hours value",
    COMPONENT: "Please select at least one component.",
};



